export function getTrackCookies(req: any): boolean {
  const trackCookies = req.cookies["track"] || "";
  return trackCookies === "true";
}
